import { Box, Typography } from "@mui/material";
import { styledComponent } from "../utils/styled";
import { DraftStatusIcon, ActiveStatusIcon, InactiveStatusIcon } from "./icons";

const STATUS_PILL_COLORS = {
  DRAFT: {
    bgDark: "rgba(65,69,75,0.8)",
    borderDark: "#6A7079",
    textDark: "#ECEFF3",
    iconDark: "#A8AEB6",
    bgLight: "#DDE1E3",
    borderLight: "rgba(168,174,182,0.5)",
    textLight: "#434950",
    iconLight: "#434950",
  },
  ACTIVE: {
    bgDark: "rgba(71,213,166,0.2)",
    borderDark: "rgba(71,213,166,0.2)",
    textDark: "#47D5A6",
    iconDark: "#47D5A6",
    bgLight: "rgba(36,161,72,0.1)",
    borderLight: "rgba(36,161,72,0.2)",
    textLight: "#24A148",
    iconLight: "#24A148",
  },
  INACTIVE: {
    bgDark: "#252727",
    borderDark: "#3D3D3D",
    textDark: "#ECEFF3",
    iconDark: "#A8AEB6",
    bgLight: "#F5F5F5",
    borderLight: "#E4E4E4",
    textLight: "#434950",
    iconLight: "#434950",
  },
};

const STATUS_PILL_LABELS = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

const STATUS_PILL_ICONS = {
  DRAFT: DraftStatusIcon,
  ACTIVE: ActiveStatusIcon,
  INACTIVE: InactiveStatusIcon,
};

const PillRoot = styledComponent(Box)(({ isDark, status }) => {
  const colors = STATUS_PILL_COLORS[status];
  return {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "2px 9px",
    borderRadius: "100px",
    border: "1px solid",
    borderColor: isDark ? colors.borderDark : colors.borderLight,
    backgroundColor: isDark ? colors.bgDark : colors.bgLight,
  };
});

const PillLabel = styledComponent(Typography)(({ isDark, status }) => {
  const colors = STATUS_PILL_COLORS[status];
  return {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 500,
    lineHeight: "16.5px",
    color: isDark ? colors.textDark : colors.textLight,
  };
});

// Muted "--" is intentionally the same color in both themes.
const PillEmptyLabel = styledComponent(Typography)({
  fontFamily: "Inter",
  fontSize: "12px",
  fontWeight: 500,
  color: "#6A7079",
});

// Non-DPM files/folders (no status) render "--" instead.
export function DpmStatusPill({ status, isDark }) {
  const colors = STATUS_PILL_COLORS[status];
  if (!status || !colors) {
    return <PillEmptyLabel>--</PillEmptyLabel>;
  }

  const StatusIcon = STATUS_PILL_ICONS[status];
  const iconColor = isDark ? colors.iconDark : colors.iconLight;

  return (
    <PillRoot isDark={isDark} status={status}>
      <StatusIcon width={11} height={11} color={iconColor} />
      <PillLabel isDark={isDark} status={status}>
        {STATUS_PILL_LABELS[status]}
      </PillLabel>
    </PillRoot>
  );
}
